// The exact inverse of config-manager templateService.applyTemplate, which writes
//   audience_values[audience_id] = stringValue
//   priorities[audience_id]      = templateParam.priority || 999
// so copying an audience back out is a pure client-side read.
//
// CommonJS on purpose (the rest of src/util/ is ESM): `npm test` runs node --test with no
// "type": "module", so the tests can only require it. Webpack interop handles the import.

// The one definition of "this audience's parameters": an explicit override, so a parameter
// deliberately set to "" or "false" counts. Returns the whole parameter docs.
function audienceParameters(parameters, audienceId) {
  if (!parameters || !audienceId) return [];
  return parameters.filter(
    param => param.audience_values && param.audience_values[audienceId] !== undefined
  );
}

// Values in audience_values are already strings (applyTemplate stringifies on the way in) —
// pass them through verbatim, TemplateEdit.saveTemplate re-parses JSON on save.
// Priority falls back to 999 like applyTemplate, never saveTemplate's `|| 1`, which would
// silently promote the parameter above every other audience on the way back.
function buildTemplateParameters(parameters, audienceId) {
  return audienceParameters(parameters, audienceId).map(param => ({
    id: param.id,
    key: param.key,
    value: param.audience_values[audienceId],
    priority: (param.priorities && param.priorities[audienceId]) ?? 999
  }));
}

module.exports = { audienceParameters, buildTemplateParameters };
